import { Navigate, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { api } from '@/lib/api'

interface MeResponse {
  id: string
  email: string
  isAdmin: boolean
}

export function AdminRoute() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['auth', 'me', 'admin-check'],
    queryFn: () => api.get<MeResponse>('/auth/me'),
    retry: false,
    staleTime: 1000 * 10,
  })

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    )
  }

  if (error) {
    return <Navigate to="/" replace />
  }

  if (!data?.isAdmin) {
    return <Navigate to="/forbidden" replace />
  }

  return <Outlet />
}
